// extracted by mini-css-extract-plugin
module.exports = {"BASE":"mainLayout-module--BASE--bYygp"};